export default __webpack_public_path__ + "static/media/upload_image.7fd258bf.png";